import React from 'react';

import { useCurrentUser } from 'Auth';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import {
  useLoadInfluencerChannel,
  useUpdateInfluencerChannel,
  useCreateInfluencerChannel,
  useIsUpdating,
} from 'scenes/Influencers/InfluencersChannels/data';

import InfluencerChannelForm from './InfluencerChannelForm';
import {
  NAME,
  OWNER,
  MALE,
  FEMALE,
  AGE_GENDER_DISTRIBUTION,
  AGE_GROUP_NAME,
  AGE_LIST,
} from './constants';

const defaultAgeGenderDistribution = {
  [AGE_GENDER_DISTRIBUTION]: AGE_LIST.map((age) => ({
    [AGE_GROUP_NAME]: age,
    [MALE]: '',
    [FEMALE]: '',
  })),
};

export const InfluencerChannelFormCreate = ({
  onClose,
  onExited,
  onSubmit,
  open,
}) => {
  const [createInfluencerChannel] = useCreateInfluencerChannel();
  const isUpdating = useIsUpdating();

  const user = useCurrentUser();
  const handleSubmit = async (values = {}) => {
    await createInfluencerChannel(values);
    onSubmit();
  };

  return (
    <InfluencerChannelForm
      title={'Add Influencer Channel'}
      loading={isUpdating}
      onClose={onClose}
      initialValues={{
        [OWNER]: user.id,
        ...defaultAgeGenderDistribution,
      }}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
    />
  );
};

export const InfluencerChannelFormEdit = ({
  id,
  onClose,
  onSubmit,
  onExited,
  open,
}) => {
  const { data, isLoading } = useLoadInfluencerChannel(id);
  const [updateInfluencerChannel] = useUpdateInfluencerChannel();
  const isUpdating = useIsUpdating();

  const handleSubmit = async (values) => {
    await updateInfluencerChannel(values);
    onSubmit();
  };

  return (
    <InfluencerChannelForm
      title={'Edit Influencer Channel'}
      subTitle={data?.[NAME]}
      entityId={id}
      loading={isLoading || isUpdating}
      onClose={onClose}
      initialValues={{
        ...data,
        ...(isEmpty(get(data, AGE_GENDER_DISTRIBUTION))
          ? defaultAgeGenderDistribution
          : {}),
      }}
      active={!!data}
      onSubmit={handleSubmit}
      isEdit={true}
      onExited={onExited}
      open={open}
    />
  );
};
